// extracted by mini-css-extract-plugin
export default {"container":"app-toggle_container__UpPEC","container-icon":"app-toggle_container-icon__vJWep","container-icon-svg":"app-toggle_container-icon-svg__GcCD-"};